import * as React from 'react'

import type { Back } from 'modules/core/components/Card/types'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import templates from 'modules/reports/store/collections/templates'

import Content from './components/Content'

interface Props {
  back: Back
  loading: boolean
  selectedCategory: string | null | undefined
}

const Templates = ({ back, loading, selectedCategory }: Props) => {
  const { loading: loadingTemplates } = useAsyncData(() => {
    return Promise.all([templates.fetch({})])
  }, [])

  return (
    <ResponsivePage.Body
      loading={loading || loadingTemplates}
      showHeader={false}
      error={null}
      variant="full"
    >
      <Content selectedCategory={selectedCategory} loadingTemplates={loadingTemplates} />
    </ResponsivePage.Body>
  )
}

export default Templates
